import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import InteractiveETLDemo from './InteractiveETLDemo.jsx';

const VideoDemoSection = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        py: { xs: 4, sm: 5, md: 6 },
        background: 'linear-gradient(180deg, #0F0F1A 0%, #1A0F2A 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Container maxWidth="xl" sx={{ px: { xs: 4, sm: 6, md: 8, lg: 12 } }}>
        <Box
          sx={{
            textAlign: 'center',
            mb: { xs: 4, sm: 5, md: 8 },
          }}
        >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'Sora, sans-serif',
                fontWeight: 700,
                fontSize: { xs: '2rem', sm: '2.5rem', md: '3rem', lg: '48px' },
                lineHeight: '100%',
                letterSpacing: '0%',
                textAlign: 'center',
                mb: { xs: 2, sm: 2.5, md: 3 },
                background: 'linear-gradient(180deg, #F6F6F7 0%, #7E808F 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Experience What the Platform Can Do
            </Typography>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <Typography
              sx={{
                fontFamily: 'Manrope, sans-serif',
                fontWeight: 400,
                fontSize: { xs: '14px', sm: '15px', md: '16px' },
                lineHeight: '160%',
                letterSpacing: '0px',
                textAlign: 'center',
                color: '#FFFFFFCC',
                maxWidth: '800px',
                mx: 'auto',
                px: { xs: 1, sm: 0 },
              }}
            >
              Build your own ETL pipeline in real-time. Select a data source, add transformations, and watch it execute with live monitoring.
            </Typography>
          </motion.div>
        </Box>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <InteractiveETLDemo />
        </motion.div>
      </Container>
    </Box>
  );
};

export default VideoDemoSection;
